import { FC, useEffect, ChangeEvent } from "react";
import Typography from "@mui/material/Typography";
import { getSurveySection } from "app/features/surveySlice";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { FormControlModel } from "types";
import FormComponentFactory from "lib/factory/FormComponentFactory";
import { ElementType } from "lib/enums/enums";
import StepContent from "../StepContent";
import { NO } from "pages/SurveyForm/constants/uiControls";

type Props = {
  formik: any;
  sectionId: number;
};

const Step4: FC<Props> = ({ formik, sectionId }) => {
  const dispatch = useAppDispatch();
  const { surveySection } = useAppSelector((state) => state.survey) ?? [];
  const { questions = [] } = surveySection || {};

  useEffect(() => {
    dispatch(getSurveySection(sectionId));
  }, []);

  const clearFieldsConditioned = (value: string) => {
    if (value === NO) {
      formik.setFieldValue("cellPhoneNumber", { ...formik?.values?.cellPhoneNumber, value: "" });
      formik.setFieldValue("cellPhoneCompany", { ...formik?.values?.cellPhoneCompany, value: "" });
    }
  };

  const dataModel: Array<FormControlModel> = [
    {
      key: 0,
      formik,
      visible: true,
      name: "hasCellPhone",
      label: "Tiene celular?",
      questionData: questions[0],
      elementType: ElementType.Radio,
      onChangeCallback: clearFieldsConditioned,
    },
    {
      key: 1,
      formik,
      name: "cellPhoneNumber",
      label: "Número de celular",
      elementType: ElementType.Textfield,
      questionData: questions[0]?.subQuestions[0],
      visible: formik.values.hasCellPhone?.value === "81C0A4CC-543E-4A79-8E8E-19AE5EADCBA3",
    },
    {
      key: 2,
      formik,
      label: "Operador",
      name: "cellPhoneCompany",
      elementType: ElementType.Select,
      questionData: questions[0]?.subQuestions[1],
      visible: formik.values.hasCellPhone?.value === "81C0A4CC-543E-4A79-8E8E-19AE5EADCBA3",
    },
    {
      key: 3,
      formik,
      name: "email",
      visible: true,
      maxLength: 70,
      questionData: questions[1],
      elementType: ElementType.Textfield,
      label: "Correo electrónico corporativo",
    },
    {
      key: 4,
      formik,
      name: "emergencyContactName",
      visible: true,
      maxLength: 70,
      questionData: questions[2],
      elementType: ElementType.Textfield,
      label: "Nombre del contacto de emergencia",
    },
    {
      key: 5,
      formik,
      name: "relationshipEmergencyContact",
      visible: true,
      maxLength: 70,
      questionData: questions[3],
      elementType: ElementType.Textfield,
      label: "Parentesco del contacto de emergencia",
    },
    {
      key: 6,
      formik,
      name: "emergencyContactPhoneNumber",
      visible: true,
      maxLength: 70,
      questionData: questions[4],
      elementType: ElementType.Textfield,
      label: "Número telefónico del contacto de emergencia",
    },
  ];

  return (
    <div>
      <Typography mb={2} variant='subtitle1' align='center'>
        Cuéntenos sobre usted: información de contacto
      </Typography>
      <StepContent>{dataModel.map(FormComponentFactory)}</StepContent>
    </div>
  );
};

export default Step4;
